import api from '@/apis'
import { sortDateRangeParams } from '@/utils/dateRange'
import { createLatestOnly } from '@/utils/latestOnly'

const search = createLatestOnly()

export default {
  state: {
    // `status` is the send attempt (did the gateway accept the request);
    // `delivery_status` is the latest delivery receipt reported back by the provider.
    status_list: [
      { title: 'All', value: null },
      { title: 'Success', value: 'success' },
      { title: 'Pending', value: 'pending' },
      { title: 'Failed', value: 'failed' }
    ],
    delivery_status_list: [
      { title: 'All', value: null },
      { title: 'Pending', value: 'pending' },
      { title: 'Delivered', value: 'delivered' },
      { title: 'Failed', value: 'failed' },
      { title: 'Undelivered', value: 'undelivered' },
      { title: 'Unknown', value: 'unknown' }
    ],
    headers: [
      { text: '#', value: 'index', sortable: false, width: 70 },
      { text: 'Send Time', value: 'create_datetime', sortable: true, width: 180 },
      { text: 'Status', value: 'status', sortable: true, width: 100 },
      { text: 'Delivery Status', value: 'delivery_status', sortable: true, width: 140 },
      { text: 'Delivery Updated At', value: 'delivery_updated_at', sortable: true, width: 180 },
      { text: 'Ticket Code', value: 'code', sortable: true, width: 110 },
      { text: 'Service Type / Prefix', value: 'service_type', sortable: false, width: 160 },
      { text: 'Tel', value: 'tel', sortable: false, width: 110 },
      { text: 'Language', value: 'language', sortable: true, width: 110 },
      { text: 'SMS Threshold', value: 'sms_threshold', sortable: true, width: 110 },
      { text: 'Message', value: 'message', sortable: false },
      { text: 'Provider / Error', value: 'provider_error', sortable: false }
    ],
    items: []
  },
  mutations: {
    SET_SMS_LOGS_ITEMS(state, payload) {
      state.items = payload
    }
  },
  actions: {
    async fetchSmsLogs({ commit }, payload) {
      const isLatest = search()
      try {
        commit('SET_SNACKBAR', { status: true, color: 'loading', text: 'Loading SMS logs...', loading: true })
        // Reversed picker order would become an empty BETWEEN — see utils/dateRange.js.
        const response = await api.getSmsLogs(sortDateRangeParams(payload))
        if (!isLatest()) return
        if (response.data.success) {
          commit('SET_SNACKBAR', { status: true, color: 'success', text: 'Success', icon: 'check', timeout: '2000' })
          commit('SET_SMS_LOGS_ITEMS', response.data.data)
        } else {
          commit('SET_SNACKBAR', { status: true, color: 'error', text: response.data.message, icon: 'close', timeout: '2000' })
        }
      } catch (error) {
        if (!isLatest()) return
        commit('SET_SNACKBAR', { status: true, color: 'error', text: 'Server Occur Error', icon: 'close', timeout: '2000' })
      }
    }
  }
}
